export default "__VITE_ASSET__ClP9KO1h__"